import { CircularProgress, Box } from "@mui/material";
import React from "react";

interface LoadingOverlayProps {
	isLoading: boolean;
	children: React.ReactNode;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
	isLoading,
	children,
}) => {
	return (
		<Box position="relative">
			{children}

			{isLoading && (
				<Box
					sx={{
						position: "absolute",
						top: 0,
						left: 0,
						right: 0,
						bottom: 0,
						backgroundColor: "rgba(255, 255, 255, 0.7)",
						zIndex: 999, // Hält das Overlay über allem
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
					}}
				>
					<CircularProgress />
				</Box>
			)}
		</Box>
	);
};

export default LoadingOverlay;
